module.exports = __webpack_public_path__ + "img/blackLock.5ee4557e.svg";